<template>
<div class="container-fluid">
  <div class="row mobile flex-nowrap">
    <SideBar id="desktop" />
    <MobileSideBar id="mobile" />
    <HomeTable id="hometable" />
  </div>
</div>
</template>

<script>
import SideBar from '@/components/SideBar.vue'
import HomeTable from '@/components/HomeTable.vue'
import MobileSideBar from '@/components/MobileSideBar.vue'

export default {
  name: 'Statistics',
  components: {
    SideBar,
    HomeTable,
    MobileSideBar
  }
}
</script>

<style scoped>
#mobile{
    display: none
  }
#desktop{
  max-width: 100%
}
@media screen and (max-width: 768px){
  #mobile{
    display: flex;
  }
  #desktop{
    display: none
  }
  .mobile{
    display: grid
  }
}
</style>
